import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

const RenameDialog = ({ isOpen, formName, onClose, onConfirm, onChange }) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="tw:!w-lg">
                <DialogHeader>
                    <DialogTitle>Rename Draft</DialogTitle>
                </DialogHeader>
                <DialogDescription>
                    <Input type="text" value={formName} onChange={onChange} placeholder="Enter new name" autoFocus />
                </DialogDescription>
                <DialogFooter className="tw:gap-4 tw:py-4">
                    <Button variant="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} disabled={!formName.trim()} className="tw:px-12">
                        Save
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default RenameDialog
